import { Component, OnInit } from '@angular/core';
import { BaseService } from '../../base.service';
import { BankService } from '../../services/bank.service';
import { BankListItem } from '../../models/bankListItem';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operator/map';

@Component({
  selector: 'app-bank-list',
  templateUrl: './bank-list.component.html',
  styleUrls: [ ]
})
export class BankListComponent implements OnInit {

  constructor(
    private baseService : BaseService ,
    private bankService : BankService,
    private router: Router,
  ) { }

  titleComponent:string;
  titlePanel:string;
  banks:BankListItem[] = [];

  ngOnInit() {
    this.titleComponent = 'Sliders';
    this.titlePanel = 'Lista de Sliders';
    this.baseService.changedComponentName(this.titleComponent);

    this.list();
  }

  list() {
    this.bankService.getAll().subscribe( (data) => {
      if (data) {
        console.log(data);
        data.map( d=>{
          this.banks.push(
              <BankListItem>{ 
                status: d.status ,
                name: d.name ,
                creationDate: d.creationDate,
                creationUser: d.creationUser.email,
                id: d.id 
              });
        })
        
        //this.banks = data;
        //console.log(this.banks);
      }
    });
  }

  get(event, id: number) {
    const link = ['/dashboard/bank', id];
    this.router.navigate(link);
  }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/bank/bank-list.component.ts